import { Routes } from '@angular/router';
import { accessControlGuard } from '@data-terminal/data-access/route-guards';
import { activateForCloudAdminOrMember } from '@data-terminal/data-access/route-guards/access-control/master-access-control';
import { canActivateNotificationsSettingsGuard } from '@data-terminal/feature-notifications/guards/can-activate-notifications-settings.guard';
import { ROUTE_PARAMS, ROUTE_PATH, RouteData } from '@data-terminal/shared-models/navigation';

const DC_APP_TITLE = 'DC.APP.TITLE';

export const ROUTES: Routes = [
    {
        path: `${ROUTE_PATH.error}`,
        loadChildren: () => import('./pages/error-page/error-page.component'),
    },
    {
        path: `${ROUTE_PATH.userNotFound}`,
        loadChildren: () => import('./pages/user-not-found-page/user-not-found-page.component'),
    },
    {
        path: `${ROUTE_PATH.orgNotFound}`,
        loadChildren: () => import('./pages/org-not-found-page/org-not-found-page.component'),
    },
    {
        path: `:${ROUTE_PARAMS.orgId}`,
        redirectTo: `:${ROUTE_PARAMS.orgId}/${ROUTE_PATH.dashboard}`,
        pathMatch: 'full',
    },
    {
        path: `:${ROUTE_PARAMS.orgId}/`,
        redirectTo: `:${ROUTE_PARAMS.orgId}/${ROUTE_PATH.dashboard}`,
        pathMatch: 'full',
    },
    {
        path: `:${ROUTE_PARAMS.orgId}`,
        canActivate: [activateForCloudAdminOrMember],
        data: { isNavigationHidden: true, title: DC_APP_TITLE } as RouteData,
        children: [
            {
                path: `${ROUTE_PATH.welcome}`,
                canActivate: [accessControlGuard],
                loadChildren: () => import('./pages/welcome-page/welcome-page.component'),
            },
            {
                path: `${ROUTE_PATH.farewell}`,
                canActivate: [accessControlGuard],
                loadChildren: () => import('./pages/farewell-page/farewell-page.component'),
            },
            {
                path: `${ROUTE_PATH.onlinePress}`,
                canActivate: [accessControlGuard],
                loadChildren: () => import('./pages/online-press-page/online-press-page.component'),
            },
            {
                path: `${ROUTE_PATH.dashboard}`,
                canActivate: [accessControlGuard],
                loadChildren: () => import('./pages/dashboards-page/dashboards-page.component'),
            },
            {
                path: `${ROUTE_PATH.notifications}`,
                canActivate: [accessControlGuard, canActivateNotificationsSettingsGuard],
                loadChildren: () => import('./pages/notifications-page/notification-settings-page.component'),
                data: {
                    title: 'NOTIFICATIONS_SETTINGS.TITLE',
                    isNavigationHidden: true,
                    isSecondLevel: true,
                    breadcrumbs: [
                        {
                            text: DC_APP_TITLE,
                            routerLink: [ROUTE_PARAMS.orgId],
                        },
                        {
                            text: 'NOTIFICATIONS_SETTINGS.TITLE',
                        },
                    ],
                } as RouteData,
            },
            {
                path: `${ROUTE_PATH.dieCuttingTools}`,
                canActivate: [accessControlGuard],
                loadComponent: () =>
                    import('@data-terminal/feature-settings/pages/die-cutting-tools/die-cutting-tools.component').then(
                        (module) => module.DieCuttingToolsComponent
                    ),
                data: {
                    title: 'DC.SETTINGS.TOOL_USAGE.TITLE',
                    isNavigationHidden: true,
                    isSecondLevel: true,
                    isLegalLineHidden: true,
                    goToParentSegments: -1,
                    breadcrumbs: [
                        { text: DC_APP_TITLE, routerLink: [ROUTE_PARAMS.orgId] },
                        { text: 'DC.SETTINGS.TOOL_USAGE.TITLE' },
                    ],
                } as RouteData,
            },
            {
                path: `${ROUTE_PATH.settings}`,
                canActivate: [activateForCloudAdminOrMember],
                loadChildren: () => import('./pages/settings-page/settings-page.component'),
                data: {
                    title: 'DC.SETTINGS.TITLE',
                    isNavigationHidden: true,
                    isSecondLevel: true,
                    breadcrumbs: [
                        {
                            text: DC_APP_TITLE,
                            routerLink: [ROUTE_PARAMS.orgId],
                        },
                        {
                            text: 'DC.SETTINGS.TITLE',
                        },
                    ],
                } as RouteData,
            },
        ],
    },
];
